<script setup>
defineOptions({ name: "SupportNeedHelpSection" });

defineProps({
  whatsAppLink: { type: String, default: "" },
  portalUrl: { type: String, default: "" },
});
</script>

<template>
  <section class="overflow-hidden relative bg-gradient-to-r from-[#006086] to-[#004d6b]">
    <div class="absolute inset-0">
      <svg
        class="absolute inset-0 w-full h-full"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 1463 360"
      >
        <path
          class="text-[#004d6b] text-opacity-40"
          fill="currentColor"
          d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z"
        />
        <path
          class="text-[#003d56] text-opacity-40"
          fill="currentColor"
          d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z"
        />
      </svg>
    </div>

    <div class="relative px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8">
      <div class="grid gap-8 lg:grid-cols-2 lg:items-center">
        <div>
          <h2 class="text-4xl font-extrabold text-white sm:text-5xl">
            Não encontrou o que precisava?
          </h2>
          <p class="mt-4 text-lg text-[#e6f0f4] max-w-3xl">
            Nossa equipe está pronta para te atender. Entre em contato pelo
            canal de sua preferência.
          </p>
        </div>
        <div class="flex flex-col gap-3 sm:flex-row lg:justify-end">
          <a
            :href="whatsAppLink"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center justify-center px-6 py-4 text-xl font-medium text-[#006086] bg-white border-2 border-white rounded-xl shadow-xl transition-colors hover:bg-[#e6f0f4]"
          >
            Falar pelo WhatsApp
          </a>
          <a
            :href="portalUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex justify-center items-center px-6 py-4 text-xl font-medium text-white rounded-xl border-2 border-[#007ba8] transition-colors hover:bg-[#004d6b]"
          >
            Abrir chamado
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
